import axios from 'axios';

import { API_URL } from '../config/apiConfig';

const importTimecards = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_URL}/api/import/timecards`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data?.error || 'Failed to import timecards';
  }
};

const importService = {
  importTimecards,
};

export default importService;
